import { RowLayout } from '../../../../../Vendors/VendorCreation/General/VendorForm/RowLayout'
import { FieldWithLabel } from '../../../../../../../components/FieldWithLabel/FieldWithLabel'
import { LABELS } from '../../../../../../../constants'
import { LinkHighlighter } from '../../../../../../../components/LinkHighlighter/LinkHighlighter'
import {
  formatAddress,
  formatPhoneNumber
} from '../../../../../../../helper/common'
import { Typography } from '../../../../../../../components/Typography'
import {
  ability,
  ACTIONS,
  SUBJECTS,
  SubjectWithAttributes
} from 'features/Permission'
import { subject } from '@casl/ability'
import { useMemo } from 'react'
import cn from 'classnames'
import { TAddEditHospitalResponse } from 'components/Forms/forms.addEditHospital.d'

export const GeneralHospitalDetails = ({
  details,
  hsId
}: {
  details: TAddEditHospitalResponse
  hsId?: string
}) => {
  const canSeeLegalName = useMemo(
    () =>
      ability.can(
        ACTIONS.VIEW,
        subject(SUBJECTS.HOSPITAL_LEGAL_NAME, {
          ...details,
          uuid: hsId
        } as unknown as SubjectWithAttributes)
      ),
    [details, hsId]
  )

  return (
    <>
      <RowLayout title={'Business information'}>
        <div className={cn('row mt-12', { 'two-columns': canSeeLegalName })}>
          <FieldWithLabel
            className={cn({ 'half-width': canSeeLegalName })}
            title={
              canSeeLegalName
                ? LABELS.HOSPITAL_NAME_DOING_BUSINESS_AS
                : LABELS.HOSPITAL_NAME
            }
          >
            {details.name}
          </FieldWithLabel>
          {canSeeLegalName && (
            <FieldWithLabel title={LABELS.HOSPITAL_LEGAL_NAME}>
              {details.legal_name || '-'}
            </FieldWithLabel>
          )}
        </div>
        <div className="row two-columns">
          <FieldWithLabel className="half-width" title={LABELS.WEBSITE}>
            {details.website ? <LinkHighlighter text={details.website} /> : '-'}
          </FieldWithLabel>
          <FieldWithLabel title={LABELS.PHONE_NUMBER}>
            {formatPhoneNumber(details.phone_number) || '-'}
          </FieldWithLabel>
        </div>
      </RowLayout>
      <div className="separator mt-32 mb-24 row full-width" />
      <RowLayout title="Address">
        <Typography.Body1 className="mt-8">
          {formatAddress(details.address)}
        </Typography.Body1>
      </RowLayout>
    </>
  )
}
